import {getAdjustedPlantId} from '@hconnect/upm'
import {useQuery} from '@tanstack/react-query'

import {useAxios, useUrlParam} from '../hooks'

export const GetPlantUpmIdQueryKey = 'kmsPlants'

export const usePlantUpmId = () => {
  const {data} = useGetPlantUpmId()
  return data?.upmId
}

export const useGetPlantUpmId = () => {
  const axiosInstance = useAxios()
  const plantId = useUrlParam('plantCode')

  return useQuery({
    queryKey: [GetPlantUpmIdQueryKey, getAdjustedPlantId(plantId)],
    queryFn: async () => {
      const path = `/kms/plants/${getAdjustedPlantId(plantId)}`
      return (await axiosInstance.get<{upmId: string}>(path)).data
    },
    staleTime: Infinity
  })
}
